import { UserSetup } from "../practitioner/UserSetup";

export class HealthSystemSetup {
  id: number;
  // active: boolean;
  name: string;
  primaryPhoneNumber: string;
  secondaryPhoneNumber: string;
  primaryEmailAddress: string;
  photoUrl: string;
  practiceWebsite: string;
  practiceType: number=0;
  addressId: number | null;
  address2Id: number | null;
  faxNumber: string;
  specialty: string;
  subSpecialty: string;
  npi: string;
  // npitype: string;
  // providerType: string;
  // practiceManagerName: string;
  // practiceManagerNumber: string;
  // practiceManagerEmail: string;
  // notes: string;
  // primarySpecialtyId: number | null;
  logoUrl: string;
  // otherOrganizationName: string;
  // tierId: number | null;
  // tierCreateDate: string | null;
  // tierBillingCycle: number | null;
  // profileClaimed: boolean | null;
  // profileClaimedBy: number | null;
  // conditions: string;
  // registrationCode: string;
  // testingSite: boolean | null;
  // locationId: number | null;
  // locationName: string;
  // healthOrganizationId: number | null;
  // location: GlobalLocation;
  // isFavorite: boolean;
  // practitionerIds: number[];
  // isInNetwork: boolean;
  // workingHours: WorkingHours[] = [];
  // lastUpdatedOn: string;
  // healthSystemInsurance: Insurance[] = [];
  // bio: string;
  users: UserSetup[];
  practiceManagerUser: UserSetup;
}
